import { Analytics } from "../utils/analytics/analytics";
import { ResponsiveUtils } from "@sazka/utils/responsive-utils";
import { TimeoutTimer } from "@sazka/utils/timer";

$(function () {
    let $root = $(".homepage-carousel");
    if (!$root.length) {
        return;
    }
    const vertical = Analytics.vertical;

    // in case there are multiple carousels
    $root = $($root[0]);

    const $images = $root.find(".homepage-carousel__image");

    const $slides = $root.find(".homepage-carousel__slide");
    const $firstSlide = $slides.first();
    setNavigationColor($firstSlide);

    const pushedSlides: number[] = [];

    datalayerPushCarousels($firstSlide, $firstSlide.data("slide-id"));

    let lastPosition = window.scrollY;
    const parallaxCoeficient = 0.1;

    // parallax effect only on non-mobile screens
    if ($root.data("disable-parallax") === undefined) {
        window.addEventListener(
            "scroll",
            () => {
                onScroll();
            },
            {
                passive: true,
            }
        );
    }

    // if there is only one carousel, binding fading events, stepper and timers is waste of resources
    if ($slides.length <= 1) {
        return;
    }

    const slideTimeout = 6000;
    let timer = new TimeoutTimer(() => {
        goToNextSlide();
    }, slideTimeout);

    if (ResponsiveUtils.breakpointUp("sm")) {
        $root.on("mouseenter", mouseIn);
        $root.on("mouseleave", mouseOut);

        $root.find(".homepage-carousel__menu--item").on("click", (e) => {
            const $elem = $(e.currentTarget);
            if ($elem.hasClass("active")) {
                return;
            }

            const slideId = $elem.data("slide-id");
            changeActiveElements($elem);
            setNavigationColor($(`.homepage-carousel__slide[data-slide-id=${slideId}]`));
        });
    }

    function goToNextSlide() {
        const $currentSlide = $root.find(".homepage-carousel__slide.active");
        if ($currentSlide.length) {
            let $nextSlide = $currentSlide.next();
            if (!$nextSlide.length) {
                $nextSlide = $root.find(".homepage-carousel__slide").first();
            }

            changeActiveElements($nextSlide);
            setNavigationColor($nextSlide);
        }
    }

    function changeActiveElements(slide) {
        const slideId = slide.data("slide-id");

        $root.find(".homepage-carousel__menu--item, .homepage-carousel__slide").removeClass("active");

        // change active slide
        const trueSlide = $root.find(`.homepage-carousel__slide[data-slide-id=${slideId}]`);
        trueSlide.addClass("active");

        // change active slide in menu
        $root.find(`.homepage-carousel__menu--item[data-slide-id=${slideId}]`).addClass("active");

        //push active slide to DL
        datalayerPushCarousels(trueSlide, slideId);

        resetTimer();
    }

    function mouseIn() {
        $root.addClass("hover");
        timer.pause();
    }

    function mouseOut() {
        $root.removeClass("hover");
        timer.resume();
    }

    function resetTimer() {
        if (timer) {
            timer.clear();

            timer = new TimeoutTimer(() => {
                goToNextSlide();
            }, slideTimeout);

            if ($root.hasClass("hover")) {
                timer.pause();
            }
        }
    }

    function datalayerPushCarousels($slide, $slideId) {
        if (typeof $slideId !== "undefined" && !pushedSlides.includes($slideId) && vertical === "") {
            pushedSlides.push($slideId);

            const { $slideImg, codename, index } = getSlideData($slide);

            Analytics.actionImpressPromo(
                codename,
                "home.carousel",
                $slideImg.attr("src") || $slideImg.attr("data-src"),
                `home.carousel.${index}`
            );

            const carouselSlide = $root.find(`.homepage-carousel__slide[data-slide-id=${$slideId}]`);

            carouselSlide.on("click", () => {
                datalayerPushCarouselClick($slide);
            });
        }
    }

    function datalayerPushCarouselClick($slide) {
        const { $slideImg, codename, index } = getSlideData($slide);

        Analytics.actionShowPromo(
            codename,
            "home.carousel",
            $slideImg.attr("src") || $slideImg.attr("data-src"),
            `home.carousel.${index}`
        );
    }

    function getSlideData($slide) {
        const $slideImg = $slide.find(".homepage-carousel__image");
        const codename = $slide.data("a-codename");
        const index = $slide.data("a-index");
        return { $slideImg, codename, index };
    }

    function onScroll() {
        lastPosition = window.scrollY;

        requestAnimationFrame(() => {
            updateParalax(lastPosition);
        });
    }

    function updateParalax(y) {
        const yPos = y * parallaxCoeficient;
        const yPosImage = y * 0.05;
        $root.css("transform", `translate3d(0, ${yPos}px, 0)`);
        $images.css("transform", `translate3d(0, ${yPosImage}px, 0)`);
    }

    function setNavigationColor($slide) {
        const isDark = $slide?.hasClass("dark") ?? false;

        if (isDark) {
            $("header").addClass("dark");
            $(".homepage-carousel__menu--item").addClass("dark");
        } else {
            $("header").removeClass("dark");
            $(".homepage-carousel__menu--item").removeClass("dark");
        }
    }
});
